import React from 'react';
import { Link } from 'react-router-dom';

/*
 * The compass/chat-bubble logo icon used in the header brand link. Was
 * copy-pasted (identical path data) into every page that shows it.
 */
export const BrandIcon = ({ size = 24, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#9219a6"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={style}
  >
    <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
    <path d="M7 11h10" /><path d="M7 15h6" /><path d="M7 7h8" />
  </svg>
);

/*
 * Shared page-header <nav>. Every page still supplies its own look via
 * className/innerClassName/brandClassName (each page keeps its own CSS
 * module, so visual design is unchanged) - this component only owns the
 * structural skeleton that was being hand-copied into every page:
 * nav > (optional inner wrapper) > brand link > rest of the nav content.
 */
const Navbar = ({
  className,
  innerClassName,
  style,
  ariaLabel,
  brandTo = '/',
  brandClassName,
  brand,
  children,
}) => {
  const brandLink = (
    <Link to={brandTo} className={brandClassName}>
      {brand}
    </Link>
  );

  return (
    <nav className={className} style={style} aria-label={ariaLabel}>
      {innerClassName ? (
        <div className={innerClassName}>
          {brandLink}
          {children}
        </div>
      ) : (
        <>
          {brandLink}
          {children}
        </>
      )}
    </nav>
  );
};

export default Navbar;
